import { Header } from '../../../components/SubHeaderFilter/types';

const createHeadersConfig = (labels: string[], keys: string[]): Header[] => {
  const getFieldType = (key: string): 'string' | 'number' | 'date' | 'boolean' => {
    const lowerKey = key.toLowerCase();
    if (lowerKey.includes('date') || lowerKey.includes('createdat') || lowerKey.includes('updatedat')) return 'date';
    if (
      lowerKey.includes('qtd') ||
      lowerKey.includes('quantity') ||
      lowerKey.includes('mm') ||
      lowerKey.includes('kg') ||
      lowerKey.includes('cost') ||
      lowerKey.includes('weight') ||
      lowerKey.includes('balance')||
      lowerKey.includes('dimension1')
    ) return 'number';
    if (lowerKey.startsWith('is') || lowerKey.includes('status')) return 'boolean';
    return 'string';
  };

  return labels.map((label, index) => ({
    key: keys[index] || label,
    label: label,
    type: getFieldType(keys[index] || label),
  }));
};

const stockLabels = [
  'Material',
  'Formato',
  'Acabamento',
  'Dimensão 1 (mm)',
  'Comprimento (mm)',
  'Qtd. (pç)',
  'Peso (kg)',
  'Custo (R$/kg)',
  'Descrição',
  'Código',
  'Fabricação',
  'Dimensão 2 (mm)',
  'Tratamento Térmico',
  'Densidade (g/cm³)',
  'Custo (R$/mm)',
  'Ncm',
  'Custo total',
  'País de origem',
  'Rua',
  'Prateleira',
  'Localização',
  'Certificados',
  'Notas fiscais',
  'Saldo Disponível',
  'CMC Total',
  'Markup',
  'Número de Rastreamento',
  'Família',
  'Situação',
  'Característica',
  'Data de Recebimento',
  'Ordem de Compra',
  'Nº NF',
  'Número do Certificado',
  'Número da Corrida',
];
const stockKeys = [
  'material',
  'format',
  'finishing',
  'dimension1',
  'lengthInMm',
  'quantity',
  'totalWeight',
  'costPerKg',
  'description',
  'code',
  'fabrication',
  'dimension2',
  'heatTreatment',
  'density',
  'costPerMm',
  'ncm',
  'totalCost',
  'originCountry',
  'stockStreet',
  'shelf',
  'stockLocation',
  'certificates',
  'invoice',
  'availableBalance',
  'totalCmc',
  'markup',
  'trackingNumber',
  'family',
  'stockStatus',
  'characteristic',
  'receivedDate',
  'purchaseOrder',
  'nf',
  'certificateNumber',
  'heatNumber',
];
export const stockHeaders: Header[] = createHeadersConfig(stockLabels, stockKeys);


const movementLabels = ['Pedido', 'Matéria prima', 'Tipo do movimento', 'Quantidade', 'Peso anterior', 'Peso novo', 'Comp. anterior', 'Comp. novo', 'Data'];
const movementKeys = ['ploomesOrderId', 'rawMaterialName', 'status', 'quantity', 'oldTotalWeight', 'newTotalWeight', 'oldLengthInMm', 'newLengthInMm', 'createdAt'];
export const movementHeaders: Header[] = createHeadersConfig(movementLabels, movementKeys);

const resourceLabels = ['Nome', 'Código', 'Categoria', 'Tipo', 'Cor', 'Situação'];
const resourceKeys = ['name', 'code', 'category', 'type', 'color', 'isActivated'];
export const resourceHeaders: Header[] = createHeadersConfig(resourceLabels, resourceKeys);
